/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getBuildingMaterialTypeList = (payload, callback) =>
  req.list(
    c.GET_BUILDING_MATERIAL_TYPE,
    'api/v1/rpt/administrator/buildings/settings/building_material_types?isPaginate=1',
    payload,
    callback
  );

export const getSingleMaterialType = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_BUILDING_MATERIAL_TYPE,
    `api/v1/rpt/administrator/buildings/settings/building_material_types/${id}`,
    payload,
    callback
  );

export const createBuildingMaterialType = (payload, callback) =>
  req.create(
    c.CREATE_BUILDING_MATERIAL_TYPE,
    'api/v1/rpt/administrator/buildings/settings/building_material_types',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateBuildingMaterialType = (id, payload, callback) =>
  req.update(
    c.UPDATE_BUILDING_MATERIAL_TYPE,
    `api/v1/rpt/administrator/buildings/settings/building_material_types/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeBuildingMaterialType = (id, payload, callback) =>
  req.remove(
    c.REMOVE_BUILDING_MATERIAL_TYPE,
    `api/v1/rpt/administrator/buildings/settings/building_material_types/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const createBuildingMaterial = (id, payload, callback) =>
  req.create(
    c.CREATE_BUILDING_MATERIAL,
    `api/v1/rpt/administrator/buildings/settings/building_material_types/${id}/building_materials`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateBuildingMaterial = (buildingMaterialId, id, payload, callback) =>
  req.update(
    c.UPDATE_BUILDING_MATERIAL,
    `api/v1/rpt/administrator/buildings/settings/building_material_types/${buildingMaterialId}/building_materials/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );


export const removeBuildingMaterial = (buildingMaterialId, id, callback) =>
  req.remove(
    c.REMOVE_BUILDING_MATERIAL,
    `api/v1/rpt/administrator/buildings/settings/building_material_types/${buildingMaterialId}/building_materials/${id}`,
    () => {
      if (callback) callback();
    }
  );